import { loginUser, logoutUser } from './action';

const loginUserAction = (login, password) => loginUser(login, password);
const logoutUserAction = () => logoutUser();

export default {
    loginUserAction,
    logoutUserAction,
};
